<template>
  <svg
    width="auto"
    viewBox="0 0 26 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0583 8.52801V5.59336H13.573C14.1936 5.59336 14.7175 5.38539 15.1445 4.97523L15.247 4.87125C16.0271 4.02205 15.9759 2.69914 15.1445 1.91349C14.7289 1.49755 14.1595 1.27226 13.573 1.28381H11.1416V8.52801H12.0583ZM12.0585 4.70366V2.17339H13.5961C13.9264 2.17339 14.2396 2.30048 14.4731 2.53156C14.9686 3.01681 14.98 3.82558 14.5016 4.32816C14.2681 4.57657 13.9378 4.71521 13.5961 4.70366H12.0585Z"
      fill="#3C4043"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.5229 3.95847C19.13 3.59453 18.5948 3.40967 17.9172 3.40967C17.046 3.40967 16.3911 3.73317 15.9584 4.37441L16.767 4.88855C17.063 4.4495 17.4673 4.22998 17.9798 4.22998C18.3044 4.22998 18.6175 4.3513 18.8624 4.57082C19.1015 4.77879 19.2382 5.07918 19.2382 5.39691V5.61066C18.8852 5.41424 18.441 5.31026 17.8944 5.31026C17.2566 5.31026 16.7442 5.46046 16.3627 5.76663C15.9812 6.07281 15.7876 6.47719 15.7876 6.99133C15.7762 7.45926 15.9755 7.90408 16.3285 8.20447C16.6872 8.52798 17.1428 8.68973 17.678 8.68973C18.3101 8.68973 18.8111 8.40666 19.1926 7.84053H19.2325V8.52798H20.1094V5.47201C20.1094 4.83078 19.9158 4.32241 19.5229 3.95847ZM17.0347 7.61525C16.8468 7.4766 16.7329 7.25131 16.7329 7.00868C16.7329 6.73716 16.8582 6.51187 17.1031 6.33278C17.3536 6.1537 17.6669 6.06127 18.037 6.06127C18.5496 6.05549 18.9482 6.17103 19.233 6.40211C19.233 6.79493 19.0792 7.13577 18.7774 7.42461C18.504 7.7019 18.1339 7.85788 17.7466 7.85788C17.4903 7.86365 17.2397 7.777 17.0347 7.61525Z"
      fill="#3C4043"
    />
    <path
      d="M25.1435 3.57141L22.0801 10.7058H21.1349L22.2737 8.21024L20.2637 3.57141H21.2601L22.7121 7.12996H22.7292L24.147 3.57141H25.1435Z"
      fill="#3C4043"
    />
    <path
      d="M8.8936 4.95786C8.8936 4.6748 8.87082 4.39173 8.82527 4.11444H4.95898V5.71463H7.17398C7.08288 6.22878 6.78679 6.69093 6.35404 6.97977V8.01961H7.67506C8.44946 7.2975 8.8936 6.22878 8.8936 4.95786Z"
      fill="#4285F4"
    />
    <path
      d="M4.95915 9.0248C6.0638 9.0248 6.99763 8.65508 7.67523 8.01962L6.3542 6.97979C5.98408 7.23397 5.51147 7.37839 4.95915 7.37839C3.88866 7.37839 2.9833 6.64473 2.65874 5.66266H1.29785V6.73716C1.99253 8.14094 3.41036 9.0248 4.95915 9.0248Z"
      fill="#34A853"
    />
    <path
      d="M2.65846 5.66271C2.48761 5.14857 2.48761 4.58821 2.65846 4.06829V2.99957H1.29736C0.710776 4.17228 0.710776 5.55873 1.29736 6.73143L2.65846 5.66271Z"
      fill="#FBBC04"
    />
    <path
      d="M4.95915 2.35253C5.54564 2.34098 6.10935 2.56628 6.53072 2.97643L7.7037 1.7864C6.95777 1.08162 5.97839 0.694569 4.95915 0.706123C3.41036 0.706123 1.99253 1.59576 1.29785 2.99954L2.65874 4.07404C2.9833 3.08619 3.88866 2.35253 4.95915 2.35253Z"
      fill="#EA4335"
    />
  </svg>
</template>
